////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import { shallowEqual, useSelector } from 'react-redux'

/////////STYLED/////////
const TooltipWrapper = styled.div`
	display: contents;
	justify-content: center;
	align-items: center;
`
const TextTooltip = styled.p`
	margin: 0;
`
/////////STYLED/////////

/**
 *
 * @param tooltipId
 * @param translationsKey
 * @param position
 * @param children
 * @return {JSX.Element}
 * @constructor
 */
const Tooltip = ({ tooltipId, translationsKey, position, children }) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			<TooltipWrapper
				data-tip
				data-for={tooltipId}
				data-delay-show={'600'}
				// onMouseMove={handleMouseMove}
			>
				{children}
			</TooltipWrapper>
			<ReactTooltip id={tooltipId} type="dark" effect="float" className={'tooltipWrapperExtra'} place={position}>
				<TextTooltip>{translations[translationsKey]}</TextTooltip>
			</ReactTooltip>
		</>
	)
}

Tooltip.propTypes = {
	tooltipId: PropTypes.string.isRequired,
	translationsKey: PropTypes.string.isRequired,
	position: PropTypes.string,
}
Tooltip.defaultPropTypes = {
	tooltipId: '',
	translationsKey: '',
	position: '',
}

export default Tooltip
